
const _ = require('lodash');
import ko from 'rgs-knockout';

const Serializable = require('serializable');


module.exports = function MyLeftMenuKoModel (options) {
	options = options || {};

	const model = {};

	const UserProfileServer = Serializable({
		FirstName: ko.observable(),
		LastName: ko.observable(),
		MiddleName: ko.observable(),

		IsTemporaryPassword: ko.observable(options.IsTemporaryPassword),
		RsaCheckForOsagoMode: ko.observable(options.RsaCheckForOsagoMode),
	});
	if (options.UserProfileServer) {
		UserProfileServer.fromJS(options.UserProfileServer);
	}

	const UserUI = UserProfileServer.extend({
		FullName: ko.computed(function () {
			return _.map(['LastName', 'FirstName', 'MiddleName'], function (p) {
				return UserProfileServer[p]();
			}).join(' ');
		}),

		DisableMenu: ko.computed(function () {
			return UserProfileServer.IsTemporaryPassword();
// 				|| UserProfileServer.RsaCheckForOsagoMode();
		}),
	});

// 	ko.computed(function () { // DEBUG
// 		console.trace('UserUI.DisableMenu', UserUI.DisableMenu());
// 	});

	model.User = UserUI;
	model.UserProfileServer = UserProfileServer;

	model.LogoutButtonClick = function () {
		options.LogoutButtonClick && options.LogoutButtonClick();
	};

	return model;
};

